import { Instance, types } from 'mobx-state-tree';

export const PhoneEntryFormData = types.model('PhoneEntryFormData', {
  primaryPhone: types.maybe(types.string),
  secondaryPhone: types.maybe(types.string)
});

export type PhoneEntryFormData = Instance<typeof PhoneEntryFormData>;
